import PaydownView from './PaydownView';
import PayoffView from './PayoffView';
import StatementView from './StatementView';

export default {
  paydown: PaydownView,
  payoff: PayoffView,
  statement: StatementView,
};
